import { useList } from "@refinedev/core";
import { Box, ThemeProvider, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { AgentCard } from "components";
import { DarkTheme } from "@refinedev/mui";

const Agents = () => {
    const { data, isLoading, isError } = useList({ resource: "users" });

    const allAgents = data?.data ?? [];

    if (isLoading) return <ThemeProvider theme={DarkTheme}>Loading...<CircularProgress color="warning"/></ThemeProvider>;
    if (isError) return <div>error...</div>;

    return (
        <Box>
            <Typography fontSize={25} fontWeight={700} color="#fcfcfc">
                Agents List
            </Typography>

            <Box
                mt="20px"
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "30px",
                    backgroundColor: "#fcfcfc",
                    borderRadius: "20px"
                }}
            >
                {allAgents.map((agent) => (
                    <AgentCard
                        key={agent._id}
                        id={agent._id}
                        name={agent.name}
                        email={agent.email}
                        avatar={agent.avatar}
                        noOfProperties={agent.allProperties.length}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default Agents;